import { render, staticRenderFns } from "./MapStyleDialog.vue?vue&type=template&id=235c5bc6&lang=pug&"
import script from "./MapStyleDialog.vue?vue&type=script&lang=js&"
export * from "./MapStyleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MapStyleDialog.vue"
export default component.exports